import BgDocument from "../assets/reward.png";
import Student1 from "../assets/student-1.png";
import Student2 from "../assets/student-2.png";

const RewardPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 font-sans text-gray-800 flex flex-col items-center">
      <img src={BgDocument} alt="Logo" width="100%" />
      <img src={Student1} alt="Logo" width="100%" />
      <img src={Student2} alt="Logo" width="100%" />
    </div>
  );
};

export default RewardPage;
